import { computed } from 'vue'
import { useABFeatureFlag } from '@/composables/useABFeatureFlag'
import { useCoreFeaturesStore } from '@/store/coreFeatures'

export const SIMPLE_DISMISS_WEB_VIEW_IOS = 'fstr://simple/manage_subscription/dismiss_web_view'
export const SIMPLE_DISMISS_WEB_VIEW_ANDROID = 'fstr://simple/settings_and_account_details'
export const SIMPLE_MOVE_DISMISS_WEB_VIEW = 'msga://moves/dismiss_web_view'
export const DELETE_ACCOUNT_IOS = 'fstr://path/tab/tracker/personal/delete_account'
export const WEB_FALLBACK = 'https://simple.onelink.me/k7Ew'

function pickDismissHref({ ios, android, isSimpleMove }) {
	if (isSimpleMove && (ios || android)) return SIMPLE_MOVE_DISMISS_WEB_VIEW
	if (ios) return SIMPLE_DISMISS_WEB_VIEW_IOS
	if (android) return SIMPLE_DISMISS_WEB_VIEW_ANDROID
	return null
}

export function useDismissWebViewDeeplink() {
	const {
		accountPlatform,
		IS_ACCOUNT_SIMPLE_MOVE,
		IS_AUTH0_ACCOUNT_DELETION_DEEPLINK_ACCOUNT_DELETION,
		IS_ACCOUNT_DELETION_DEEPLINK_V2_EXP,
	} = useABFeatureFlag()
	const coreFeatures = useCoreFeaturesStore()

	const iosHref = computed(() => {
		if (IS_ACCOUNT_SIMPLE_MOVE.value) return SIMPLE_MOVE_DISMISS_WEB_VIEW
		if (IS_AUTH0_ACCOUNT_DELETION_DEEPLINK_ACCOUNT_DELETION.value || IS_ACCOUNT_DELETION_DEEPLINK_V2_EXP.value) {
			return DELETE_ACCOUNT_IOS
		}
		return SIMPLE_DISMISS_WEB_VIEW_IOS
	})

	const androidHref = computed(() =>
		pickDismissHref({ ios: false, android: true, isSimpleMove: IS_ACCOUNT_SIMPLE_MOVE.value }),
	)

	const platformHref = computed(() => {
		if (accountPlatform.value.ios) return iosHref.value
		if (accountPlatform.value.android) return androidHref.value
		// Web (e.g. cancel-offer email opened in a browser): Moves users get the Moves onelink
		// from config (links.onelink.moves); everyone else the Simple onelink.
		return IS_ACCOUNT_SIMPLE_MOVE.value ? coreFeatures.FEAT_LINK_ONELINK.moves : WEB_FALLBACK
	})

	return { iosHref, androidHref, platformHref }
}

export function dismissWebView() {
	const { accountPlatform, IS_ACCOUNT_SIMPLE_MOVE } = useABFeatureFlag()
	const { ios, android } = accountPlatform.value

	const href = pickDismissHref({ ios, android, isSimpleMove: IS_ACCOUNT_SIMPLE_MOVE.value })
	if (href) {
		window.location.href = href
	} else {
		window.open(WEB_FALLBACK, '_blank')
	}
}
